import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const Sort = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M8 14L12 19L16 14H8Z" />
    <path d="M16 10L12 5L8 10L16 10Z" />
  </SvgIcon>
);
